module.exports = __webpack_public_path__ + "img/NewUI-LREXsite.e1bb42b2.png";